import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-intersection-error',
    templateUrl: './intersection-error.component.html',
    styleUrls: ['./intersection-error.component.scss'],
    standalone: false
})
export class IntersectionErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
